<template>
    <div class="page">
        <div class="split-row"></div>
        <el-row :gutter="10">
            <el-col :span="24">
                <div class="content">
                    <div class="title">
                        <div class="title-left"><span class="title-text">{{buId ? '编辑' : '新建'}}BU</span></div>
                    </div>
                    <div class="search">
                        <el-form inline>
                            <el-form-item label="BU名称">
                                <el-input v-model="buDetail.name"></el-input>
                            </el-form-item>
                        </el-form>
                        <div class="btns">
                            <button class="com-btn round" @click="save">保存</button>
                            <button class="com-btn round plain" @click="back">返回</button>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div class="split-row"></div>
        <el-row v-if="buId" :gutter="10">
            <el-col :span="6">
                <div class="left content">
                    <div class="title mb-10">
                        <div class="title-left"><span class="title-text">组织机构</span></div>
                        <div class="title-right">
                            <el-input v-model="treeSearchText" placeholder="输入关键字进行过滤"></el-input>
                        </div>
                    </div>
                    <div class="tree-container">
                        <el-tree
                        ref="tree"
                        :data="treeData"
                        node-key="id"
                        :props="{
                            children: 'childs',
                            label: 'name'
                        }"
                        default-expand-all
                        show-checkbox
                        :expand-on-click-node="false"
                        :check-strictly="true"
                        :filter-node-method="filterNode">
                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span>
                                    <i class="el-icon-office-building"></i><span> {{ node.label }}</span>
                                </span>
                            </span>
                        </el-tree>
                    </div>
                </div>
            </el-col>
            <el-col :span="18">
                <div class="right">
                    <div class="content basicData">
                        <div class="title mb-10">
                            <div class="title-left"><span class="title-text">服务区域</span></div>
                        </div>
                        <div class="search mb-10">
                            <el-form inline>
                                <el-form-item label="省">
                                    <el-select v-model="searchForm.provinceCode">
                                        <el-option label="全部" value=""></el-option>
                                        <el-option 
                                        v-for="item in provinceList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                            <div class="btns">
                                <button class="com-btn round" @click="search">查询</button>
                                <button class="com-btn round" @click="reset">重置</button>
                            </div>
                        </div>
                        <div class="mb-10">
                            <button class="com-btn round" @click="openDialog">新增</button>
                            <button class="com-btn round plain red" @click="removeBuDivision(selection)" :disabled="selection.length === 0">移除</button>
                        </div>
                        <div class="table_box">
                            <el-table :data="tableData" ref="table" class="new-table mb-10" @selection-change="(sele) => selection = sele">
                                <el-table-column type="selection" width="55"></el-table-column>
                                <el-table-column prop="provinceName" label="省"></el-table-column>
                                <el-table-column prop="cityName" label="市"></el-table-column>
                                <el-table-column label="操作">
                                    <template slot-scope="scope">
                                        <button class="com-btn text red" @click="removeBuDivision([scope.row])">删除</button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="tx-right">
                                <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="pageInfo.page"
                                :page-sizes="[10, 20, 30, 40, 50]"
                                :page-size="pageInfo.rows"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="pageInfo.total">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-dialog title="选择服务区域" :visible.sync="dialogVisible" class="new-dialog" width="400px">
            <div>
                <el-form label-width="70px" class="new-form">
                    <el-form-item label="国家" required>
                        <el-select v-model="dialogForm.nation" disabled>
                            <el-option label="中国" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="省">
                        <el-select v-model="dialogForm.province">
                            <el-option label="全部" value=""></el-option>
                            <el-option 
                            v-for="item in provinceList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="市">
                        <el-select v-model="citys" multiple>
                            <el-option 
                            v-for="item in cityList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                            :disabled="citySelected.indexOf(item.id) > -1"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer tx-center">
                <button class="com-btn round" @click="addBuDivision" :disabled="loading"><i v-if="loading" class="el-icon-loading"></i> 确定</button>
                <button class="com-btn round plain" @click="dialogVisible = false">取消</button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'ManageBuAddOrEdit',
        data () {
            return {
                buDetail: {
                    name: ''
                },
                treeSearchText: '',
                treeData: [],
                searchForm: {
                    provinceCode: ''
                },
                tableData: [],
                pageInfo: {
                    page: 1,
                    rows: 10,
                    total: 0
                },
                selection: [],
                dialogVisible: false,
                dialogForm: {
                    nation: 0,
                    province: '',
                    citys: ''
                },
                citys: [],
                provinceList: [],
                cityList: [],
                citySelected: [],
                loading: false
            }
        },
        computed: {
            buId () {
                return this.$route.query.id
            }
        },
        methods: {
            getBuDetail () {
                // 获取bu详情
                this.$store.dispatch('a:bu/getBuList', {parameters:{id: this.buId}}).then(
                    res => {
                        this.buDetail = res.list[0]
                        if (this.treeData.length > 0) {
                            this.$refs.tree.setCheckedKeys(this.buDetail.organizationIds.map(item => item.id))
                        }
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            save () {
                let parameters = {}
                parameters.name = this.buDetail.name
                if (this.buId) {
                    parameters.id = this.buDetail.id
                    parameters.organizationIds = this.$refs.tree.getCheckedKeys().map(item => {return {id: item}})
                }
                this.$store.dispatch('a:bu/saveBu', {parameters}).then(
                    res => {
                        if (!this.buId) {
                            this.$message.success('添加成功！')
                            this.$router.replace({
                                path: '/manageBuAddOrEdit',
                                query: { id: res }
                            })
                        } else {
                            this.$message.success('保存成功！')
                        }
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            back () {
                this.$router.go(-1)
            },
            getOrgTrees () {
                this.$store.dispatch('a:organization/getOrgTree', {parameters:{}}).then(
                    res => {
                        this.treeData = res
                        this.$nextTick(()=>{
                            if (this.buDetail.organizationIds) {
                                this.$refs.tree.setCheckedKeys(this.buDetail.organizationIds.map(item => item.id))
                            }
                        })
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            filterNode (value, data) {
                if (!value) return true
                return data.name.indexOf(value) !== -1
            },
            getBuDivisionList () {
                this.$store.dispatch('a:bu/getBuDivisionList', {parameters: {
                    ...this.searchForm, 
                    buId: this.buId,
                }, page: this.pageInfo.page, rows: this.pageInfo.rows}).then(
                    res => {
                        this.tableData = res.list
                        this.pageInfo.total = res.pageInfo.total
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            getSelectedDivision () {
                this.$store.dispatch('a:bu/getBuDivisionList', {parameters: {
                    ...this.searchForm, 
                    buId: this.buId,
                }, page: 1, rows: 9999}).then(
                    res => {
                        this.citySelected = res.list.map(item=>Number(item.cityId))
                    },
                    rej => {
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            search () {
                this.pageInfo.page = 1
                this.getBuDivisionList()
            },
            reset () {
                this.searchForm = this.$options.data().searchForm
                this.pageInfo = this.$options.data().pageInfo
                this.getBuDivisionList()
            },
            handleSizeChange (pageSize) {
                this.pageInfo.rows = pageSize
                this.pageInfo.page = 1
                this.getBuDivisionList()
            },
            handleCurrentChange (currentPage) {
                this.pageInfo.page = currentPage
                this.getBuDivisionList()
            },
            getDivisionSelects (parentId, list) {
                this.$store.dispatch('a:maintainAreaInfo/divisionList', {parentId: parentId}).then(
                    res => {
                        this[list] = res
                    },
                    rej => {
                        this.$message.error(rej.errorInfo)
                    }
                )
            },
            openDialog () {
                this.dialogForm = this.$options.data().dialogForm
                this.dialogVisible = true
            },
            addBuDivision () {
                this.loading = true
                this.$store.dispatch('a:bu/addBuDivision', {parameters:{
                    buId: this.buId,
                    ...this.dialogForm,
                    citys: this.citys.join(',')
                }}).then(
                    res => {
                        this.dialogVisible = false
                        this.loading = false
                        this.$message.success('添加成功！')
                        this.getBuDivisionList()
                        this.getSelectedDivision()
                    },
                    rej => {
                        this.loading = false
                        this.$message.error(rej.errorInfo);
                    }
                )
            },
            removeBuDivision (rows) {
                if (rows.length === 0) {
                    return
                }
                this.$confirm(this.$t('删除后无法恢复，确认删除选择的记录吗'), this.$t('提示'), {
                    confirmButtonText: this.$t('确定'),
                    confirmButtonClass: 'save__btn',
                    cancelButtonText: this.$t('取消'),
                    cancelButtonClass: 'back__btn',
                    type: 'warning',
                    center: true,
                    showClose: false
                }).then(()=>{
                    let ids = rows.map(sele => sele.cityId)
                    this.$store.dispatch('a:bu/removeBuDivision', {parameters: {buId: this.buId, divisionId: ids.join(',')}}).then(
                        () => {
                            this.$message.success('删除成功！')
                            this.getBuDivisionList()
                            this.getSelectedDivision()
                        },
                        rej => {
                            this.$message.error(rej.errorInfo);
                        }
                    )
                }).catch(() => {})
            }
        },
        watch: {
            treeSearchText (val) {
                this.$refs.tree.filter(val)
            },
            'dialogForm.province'(val) {
                this.citys = []
                if (val) {
                    this.getDivisionSelects(val, 'cityList')
                } else {
                    this.cityList = []
                }
            },
            buId: {
                handler (val) {
                    if (val) {
                        this.getOrgTrees()
                        this.getBuDetail()
                        this.getBuDivisionList()
                        this.getSelectedDivision()
                        this.getDivisionSelects(0, 'provinceList')
                    }
                },
                immediate: true
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
